<template>
  <div>
    <div>{{ type }}</div>
    <div>({{ category }})</div>
    <div v-if="type === 'Common Carrier'">
      <div>{{carrier}}</div>
      <div v-if="row.trackers.length === 0" class="trackers">Needs labels</div>
      <div v-if="canDownloadLabels">
        <a :href="labelsUrl" target="_blank">Download labels</a>
      </div>
    </div>
  </div>
</template>

<script>
import { downloadShippingLabelsUrl } from '../../../api.js';
export default {
  name: 'tdType',
  props: ['row'],
  computed: {
    type() {
      if (this.row.type === 'transfer') {
        return `${this.row.direction} ${this.row.category}`
      } else {
        return this.row.orderType
      }
    },
    category() {
      if (this.row.type === 'transfer') {
        return 'transfer'
      } else {
        return this.row.category
      }
    },
    needsLabels() {
      return this.row.trackers.length === 0;
    },
    canDownloadLabels() {
      if (this.type === 'Common Carrier') {
        return this.row.trackers.some(tracker => tracker.labelUrl)
      } else {
        return false;
      }
    },
    labelsUrl() {
      return downloadShippingLabelsUrl(this.row)
    },
    carrier() {
      if (this.row.requestedCommonCarrier === 'default' && this.row.trackers.length > 0) {
        let tracker = this.row.trackers[0];
        return `${tracker.carrier}::${tracker.carrierService}`
      }
      return this.row.requestedCommonCarrier
    }
  }
};
</script>

<style scoped>
.trackers {
  background-color: yellow
}
</style>


// WEBPACK FOOTER //
// src/components/OrderTable/components/tdType.vue